module.exports = __webpack_public_path__ + "static/media/Sec-3_2677_ContentBK_Mobile.35c3590e.webp";